/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Cancelimmediate2Inputs */

const zh_adminsubs_cancelimmediate2 = /** @type {(inputs: Adminsubs_Cancelimmediate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即取消`)
};

const en_adminsubs_cancelimmediate2 = /** @type {(inputs: Adminsubs_Cancelimmediate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Immediately`)
};

const es_adminsubs_cancelimmediate2 = /** @type {(inputs: Adminsubs_Cancelimmediate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar inmediatamente`)
};

/**
* | output |
* | --- |
* | "Cancel Immediately" |
*
* @param {Adminsubs_Cancelimmediate2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_cancelimmediate2 = /** @type {((inputs?: Adminsubs_Cancelimmediate2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Cancelimmediate2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_cancelimmediate2(inputs)
	if (locale === "en") return en_adminsubs_cancelimmediate2(inputs)
	return es_adminsubs_cancelimmediate2(inputs)
});
export { adminsubs_cancelimmediate2 as "adminSubs_cancelImmediate" }